import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { baseURL } from '../api/baseURL';

/**
 * Sidebar link + badge for photographers needing service assignment (same filter as Pending Assignment tab).
 */
class PhotographersSidebarNavItem extends React.Component<{ token?: string }, { count: number }> {
    pollTimer: ReturnType<typeof setInterval> | null = null;

    state = { count: 0 };

    componentDidMount(): void {
        this.refreshCount();
        this.pollTimer = setInterval(() => this.refreshCount(), 60000);
    }

    componentWillUnmount(): void {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }

    componentDidUpdate(prevProps: { token?: string }): void {
        if (prevProps.token !== this.props.token) {
            this.refreshCount();
        }
    }

    refreshCount = (): void => {
        const token = this.props.token;
        if (!token) return;
        axios
            .get(`${baseURL}/photographers?page=1&limit=1&pending=true`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((response: any) => {
                if (response?.data?.message === 'success') {
                    const total = Number(response?.data?.total) || 0;
                    this.setState({ count: total });
                }
            })
            .catch(() => {});
    };

    render(): React.ReactNode {
        const c = this.state.count;
        return (
            <li className="nav-item menu-items">
                <a className="nav-link" href="/photographers">
                    <span className="menu-icon">
                        <i className="mdi mdi-playlist-play"></i>
                    </span>
                    <span className="menu-title" style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                        Photographers
                        {c > 0 ? (
                            <span
                                className="badge badge-pill badge-danger"
                                style={{
                                    fontSize: 11,
                                    minWidth: 22,
                                    height: 22,
                                    lineHeight: '20px',
                                    padding: '0 7px',
                                    borderRadius: 11,
                                }}
                            >
                                {c > 99 ? '99+' : c}
                            </span>
                        ) : null}
                    </span>
                </a>
            </li>
        );
    }
}

const mapStateToProps = (state: any) => ({
    token: state.auth?.token,
});

export default connect(mapStateToProps)(PhotographersSidebarNavItem);
